export default {
  title: 'Menü-Änderungsverlauf',
  subtitle: 'Sehen Sie, wer Preise, Verfügbarkeit und Sichtbarkeit für {{company}} geändert hat – und wann.',
  filters: {
    type: {
      label: 'Typ',
    },
    item: {
      placeholder: 'Alle Artikel',
    },
    event: {
      label: 'Ereignis',
    },
  },
  columns: {
    when: 'Wann',
    who: 'Geändert von',
    type: 'Typ',
    item: 'Artikel',
    event: 'Ereignis',
    changes: 'Änderungen',
  },
  types: {
    product: 'Produkt',
    modifier: 'Zusatz',
    category: 'Kategorie',
    modifier_group: 'Modifizierergruppe',
    menu: 'Menü',
  },
  events: {
    created: 'Erstellt',
    updated: 'Aktualisiert',
    deleted: 'Gelöscht',
  },
  fields: {
    name: 'Name',
    description: 'Beschreibung',
    price: 'Preis',
    is_available: 'Verfügbarkeit',
    is_visible: 'Sichtbarkeit',
    is_available_for_pickup: 'Verfügbarkeit Abholung',
    is_available_for_delivery: 'Verfügbarkeit Lieferung',
    tax_category_id: 'Steuerkategorie',
    schedule: 'Angezeigte Zeiten',
    is_required: 'Pflichtauswahl',
    max_count: 'Höchstens wählbar',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Preis bei Abholung',
    delivery: 'Preis bei Lieferung',
    dine_in: 'Preis vor Ort',
    room_service: 'Preis beim Zimmerservice',
  },
  booleans: {
    on: 'Verfügbar',
    off: 'Nicht verfügbar',
    yes: 'Ja',
    no: 'Nein',
  },
  schedule: {
    always: 'Immer',
    every_day: 'Jeden Tag',
  },
  pagination: {
    previous: 'Zurück',
    next: 'Weiter',
  },
  causers: {
    orders_terminal: 'Bestellterminal',
    approved_by: {
      amigo: 'Amigo, freigegeben von {{name}}',
      assistant: 'Assistent, freigegeben von {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Im Amigo-Protokoll öffnen',
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Menü-Änderungsverlauf konnte nicht geladen werden',
  },
};
